import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUpdateCollectionModerationFromVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  moderationFrom: Types.Scalars['String'];
}>;


export type ApiUpdateCollectionModerationFrom = { updateCollectionModerationFrom: { moderationStatus: Types.ApiModerationStatus } | null };



export const ApiUpdateCollectionModerationFromDocument = /*#__PURE__*/ `
    mutation UpdateCollectionModerationFrom($id: ID!, $moderationFrom: String!) {
  updateCollectionModerationFrom(id: $id, moderationFrom: $moderationFrom) {
    moderationStatus
  }
}
    `;

export const useUpdateCollectionModerationFrom = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiUpdateCollectionModerationFrom, TError, ApiUpdateCollectionModerationFromVariables, TContext>) => {
    
    return useMutation<ApiUpdateCollectionModerationFrom, TError, ApiUpdateCollectionModerationFromVariables, TContext>(
      {
    mutationKey: ['UpdateCollectionModerationFrom'],
    mutationFn: (variables?: ApiUpdateCollectionModerationFromVariables) => apiFetcher<ApiUpdateCollectionModerationFrom, ApiUpdateCollectionModerationFromVariables>(ApiUpdateCollectionModerationFromDocument, variables)(),
    ...options
  }
    )};


useUpdateCollectionModerationFrom.fetcher = (variables: ApiUpdateCollectionModerationFromVariables, options?: RequestInit['headers']) => apiFetcher<ApiUpdateCollectionModerationFrom, ApiUpdateCollectionModerationFromVariables>(ApiUpdateCollectionModerationFromDocument, variables, options);
